import {fulfilledState, pendingState, rejectedState, resError} from "@helpers";
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import VideosService from "@services/VideosService";

export const viewVideo = createAsyncThunk(
  "video/view",
  async ({id}, {rejectWithValue}) => {
    try {
      const response = await VideosService.viewVideo({id});

      return response.data;
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

const initialState = {
  current: null,
  errors: null,
  error: "",
  status: "",
};

const viewVideoSlice = createSlice({
  name: "view-video",
  initialState,
  reducers: {
    setCurrent(state, action) {
      state.current = action.payload;
    },
    setErrors(state, action) {
      state.errors = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    setStatus(state, action) {
      state.status = action.payload;
    },
    clearView() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(viewVideo.pending, (state) => {
        pendingState(state);
      })
      .addCase(viewVideo.fulfilled, (state, action) => {
        state.current = action.payload;
        fulfilledState(state);
      })
      .addCase(viewVideo.rejected, (state, action) => {
        rejectedState(state, action);
      });
  },
});

export const {clearView, setCurrent, setError, setStatus} =
  viewVideoSlice.actions;
export default viewVideoSlice.reducer;
